import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { cardCls, fmtDateTime } from "./ui";

const Stat = ({ label, value }) => (
  <div className={`${cardCls} p-6`}>
    <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-midnight/40">{label}</p>
    <p className="font-heading text-3xl font-light text-midnight mt-2">{value}</p>
  </div>
);

export const AiSection = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/ai-analytics").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <p className="text-sm text-midnight/40 animate-pulse">Loading AI analytics…</p>;

  return (
    <div data-testid="admin-ai-section">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        <Stat label="Conversations" value={data.conversations} />
        <Stat label="Messages" value={data.messages} />
        <Stat label="Requirements Generated" value={data.requirements_generated} />
        <Stat label="Commercial Handoffs" value={data.handoffs} />
        <Stat label="RFQs From AI" value={data.ai_rfqs} />
      </div>

      <div className="grid lg:grid-cols-2 gap-4 mt-4">
        <div className={`${cardCls} p-6`}>
          <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-gold mb-5">Most Common Product Interests</p>
          {data.top_interests.length === 0 && <p className="text-sm text-midnight/40">No conversation data yet.</p>}
          <div className="flex flex-wrap gap-2">
            {data.top_interests.map((i) => (
              <span key={i.label} className="text-xs bg-midnight/[0.05] text-midnight/70 px-3 py-1.5">{i.label} <span className="font-semibold text-gold">{i.count}</span></span>
            ))}
          </div>
        </div>
        <div className={`${cardCls} p-6`}>
          <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-gold mb-5">Recent Conversations</p>
          {data.recent.length === 0 && <p className="text-sm text-midnight/40">No conversations yet.</p>}
          {data.recent.map((r) => (
            <div key={r.session_id} className="py-3 border-b border-midnight/[0.06] last:border-0">
              <p className="text-sm text-midnight/75 leading-relaxed">"{r.preview}"</p>
              <p className="text-[11px] text-midnight/40 mt-1">{r.messages} messages · {fmtDateTime(r.ts)}</p>
            </div>
          ))}
        </div>
      </div>
      <p className="text-xs text-midnight/40 mt-4">Transcripts are attached to enquiries only when a visitor explicitly hands off or submits. Idle conversation data can be purged on request.</p>
    </div>
  );
};
